export default {
    loop: true,
    muted: true,
    controls: false,
    playsinline: true,
}